/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import { PrototypeHomeView } from './PrototypeHome.view';
import { NotFoundErrorView } from '../modules/error/ErrorPages.view';
import { PrototypeUserDetailsView } from './PrototypeUserDetails.view';

export const PROTOTYPES_URL = '/prototypes';

const PROTOTYPE_USER_DETAIL_URL = PROTOTYPES_URL + '/users/details';

interface Props extends RouteComponentProps {}

class PrototypesRoutingContainer extends React.Component<Props> {
	render(): JSX.Element {
		const {
			match: { url }
		} = this.props;

		return (
			<Switch>
				<Route exact path={url} component={PrototypeHomeView} />
				<Route path={PROTOTYPE_USER_DETAIL_URL} component={PrototypeUserDetailsView} />
				<Route component={NotFoundErrorView} />
			</Switch>
		);
	}
}

export default withRouter(PrototypesRoutingContainer);
